// extracted by mini-css-extract-plugin
module.exports = {"border_right_none":"display_mode_toggle__border_right_none__8ep8O borders__border_right_none__iLfhg"};